import React from 'react';

import { PreLoginFooter } from 'components/Footer/PreLoginFooter';
import { BroadcastBannerStack } from 'PageRouter/BroadcastBannerStack';
import { PageContentWrapper } from 'PageRouter/PageContentWrapper';
import NotFoundPage from 'pages/Errors/NotFoundPage';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Masthead } from 'ui';
import { lazyWithRetry } from 'utils/lazyWithRetry';
import { PreLoginHeader } from 'components/Header/PreLoginHeader';

const FormBuilderPage = lazyWithRetry(() => import('pages/DevTools/FormBuilderPage/FormBuilderPage'));
const FormBuilderEditPage = lazyWithRetry(() => import('pages/DevTools/FormBuilderPage/FormBuilderEditPage'));
const EditSubmissionPagePreview = lazyWithRetry(
  () => import('pages/DevTools/FormBuilderPage/EditSubmissionPagePreview'),
);

const RoutesWrapper: React.FC = () => {
  return (
    <PageContentWrapper>
      <div className="flex flex-col">
        <div className="flex flex-col w-full min-h-screen max-w-screen">
          <Masthead />
          <div className="sticky top-0 z-40">
            <PreLoginHeader showLoginButton />
          </div>
          <BroadcastBannerStack />
          <div className="flex flex-grow">
            <Outlet />
          </div>
        </div>
        <PreLoginFooter />
      </div>
    </PageContentWrapper>
  );
};

const RoutesWrapperNoFooter: React.FC = () => {
  return (
    <PageContentWrapper>
      <div className="flex flex-col w-full max-w-screen">
        <Masthead />
        <div className="sticky top-0 z-40">
          <PreLoginHeader showLoginButton />
        </div>
        <BroadcastBannerStack />
        <div className="flex flex-grow">
          <Outlet />
        </div>
      </div>
    </PageContentWrapper>
  );
};

export const FormBuilderRouter: React.FC = () => {
  return (
    <Routes>
      <Route element={<RoutesWrapper />}>
        <Route path="/" element={<FormBuilderPage />} />
        <Route path="*" element={<NotFoundPage isLoggedIn={true} />} />
      </Route>

      <Route path="/edit/:mode/*" element={<FormBuilderEditRouter />} />
    </Routes>
  );
};

export const FormBuilderEditRouter: React.FC = () => {
  return (
    <Routes>
      <Route element={<RoutesWrapperNoFooter />}>
        <Route path="/" element={<FormBuilderEditPage />} />
        <Route path="/preview" element={<EditSubmissionPagePreview />} />
        <Route path="/*" element={<NotFoundPage isLoggedIn={false} />} />
      </Route>
    </Routes>
  );
};
